module.exports = __webpack_public_path__ + "img/left-blue.ae0e1196.svg";